import WidgetModule from "@eisinc/Overrides/Widgets/Header/AddressDrawerContainer";

export * from "@eisinc/Overrides/Widgets/Header/AddressDrawerContainer";

export default WidgetModule;
